import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=467e3209&scoped=true"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecifications.vue?vue&type=style&index=0&id=467e3209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e3209",
  null
  
)

export default component.exports